import React from 'react'

import { Flex, Link, Text } from '@driftt/dds'

import { useAppSelector } from 'hooks/useRedux'
import {
  Activity,
  ActivityForContact,
  ActivityType
} from 'modules/accountActivity/domain'
import { userActivityTypeToPreviewSnippet } from 'utils/activity'

import styles from './styles.module.css'

interface FormattedActivityProps {
  activity: Activity | ActivityForContact
  email?: string
}

const FormattedActivity: React.FC<FormattedActivityProps> = ({ activity }) => {
  const orgUsersById = useAppSelector(({ orgUsersById }) => orgUsersById.users)
  const { action, preview, suffix, href } = userActivityTypeToPreviewSnippet(activity, orgUsersById)
  const previewCss = {
    textDecoration: href ? 'underline' : 'none',
    textDecorationColor: '$gray4',
    flexBasis: 'fit-content'
  }

  const formatSuffix = (suffix: string) => {
    return activity.activityType !== ActivityType.SIGNAL ? suffix :
      suffix.split('|||').map((s, i) => <div key={i}>{s}</div>);
  }

  return (
    <div className={styles.activityDescription}>
      <Flex
        gap="half"
        css={{
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
        alignItems="center"
        fullWidth>
        {action && (
          <Text variant="body" 
            css={{
              color: '$gray8'
            }}>{action}</Text>
        )}
        {preview && (
          <Flex
            gap={0}
            css={{
              overflow: 'hidden'
            }}>
            {href ? 
              <Link
                css={previewCss}
                truncate
                href={href}
                target="_blank">
                {preview}
              </Link> :
              <Text css={previewCss} truncate>
                {preview}
              </Text>
            }
          </Flex>
        )}
        {suffix && (
          <Text
            css={{
              minWidth: 'fit-content',
              color: '$gray8'
            }}>
            {' '}
            {formatSuffix(suffix)}
          </Text>
        )}
      </Flex>
  </div>
  )
}

export default FormattedActivity
